import React from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useSelectedView } from 'reducers/viewsSlice';
import AddFeedbackButton from 'screens/Levelup/LevelUpCF/components/addFeedbackButton/AddFeedbackButton';
import { selectLoggedInEmployeeId } from 'selectors/loggedInEmployee';

import { FEEDBACK_FORM_TYPE } from 'constants/ProjectConstants';
import { pushFeedbackParams } from 'constants/helper';

const cohortIdsToSendMixpanelEventsFor = [-1, -2, -3];

const CFSplitButton = () => {
  const history = useHistory();
  const employeeId = useSelector(selectLoggedInEmployeeId);
  const sideNavSelectedCohort = useSelectedView();

  const handleRequestNewFeedbackClick = () => {
    // @ts-expect-error not in ts
    pushFeedbackParams({
      history,
      formType: FEEDBACK_FORM_TYPE.REQUESTED,
      newForm: true,
      empId: employeeId ?? null,
      source: cohortIdsToSendMixpanelEventsFor.includes(sideNavSelectedCohort?.id) ? sideNavSelectedCohort?.name : null,
    });
  };
  const handleShareNewFeedbackClick = (isSharePublicPraise = false) => {
    // @ts-expect-error not in ts
    pushFeedbackParams({
      history,
      formType: FEEDBACK_FORM_TYPE.PROVIDED,
      newForm: true,
      empId: null,
      source: cohortIdsToSendMixpanelEventsFor.includes(sideNavSelectedCohort?.id) ? sideNavSelectedCohort?.name : null,
      isSharePublicPraise,
    });
  };
  return (
    <Flex w="100%" mb="24px">
      <Box ml="auto">
        <AddFeedbackButton
          onClickShareFeedback={handleShareNewFeedbackClick}
          onClickRequestFeedback={handleRequestNewFeedbackClick}
        />
      </Box>
    </Flex>
  );
};

export { CFSplitButton };
